import {eyeOpenSvg as Icon__small__eyeOpenSvg} from '../Icon__small/Icon__small--eyeOpen.js';
import {eyeOpenSvg as Icon__xsmall__eyeOpenSvg} from '../Icon__xsmall/Icon__xsmall--eyeOpen.js';

export var eyeOpen = {
  name: 'eyeOpen',
  category: 'icon',
  colorable: true,
  svg: Icon__small__eyeOpenSvg,
  alt: {
    Icon__small: Icon__small__eyeOpenSvg,
    Icon__xsmall: Icon__xsmall__eyeOpenSvg,
  },
  combined: ['Icon__small', 'Icon__xsmall'],
};
